import { NetworkSetup } from "../network-setup";
import { SKRT_ABI } from "./skrt-abi";
import { SKRT_STAKING_ABI_0x7E269c080144Da40F907a0FA88d199904fF723DC } from "./staking-0x7E269c080144Da40F907a0FA88d199904fF723DC";
import { SKRT_STAKING_ABI_0x83a8eda9dbd85d17c2656bc1ad606745c2ae1d82 } from "./staking-0x83a8eda9dbd85d17c2656bc1ad606745c2ae1d82";
import { USDT_ABI } from "./usdt-abi";
import { VERIFICATION_ABI } from "./verification-abi";

export const mumbaiNetworkSetup: NetworkSetup = {
  chain: "MUMBAI",
  contracts: {
    skrt: {
      address: "0xf9D35784118580D408852A7D3ee0EFAE12aC532b",
      abi: SKRT_ABI,
      decimals: 18,
    },
    skrtStaking: {
      origins: {
        "0x83a8EDA9dBd85d17C2656Bc1aD606745C2AE1d82": SKRT_STAKING_ABI_0x83a8eda9dbd85d17c2656bc1ad606745c2ae1d82,
        "0x7E269c080144Da40F907a0FA88d199904fF723DC": SKRT_STAKING_ABI_0x7E269c080144Da40F907a0FA88d199904fF723DC,
      },
      verification: {
        address: "0x7664Bbb7237e448b942A1bbf6297596929d5f120",
        abi: VERIFICATION_ABI,
      },
    },
    usdt: {
      decimals: 18,
      address: "",
      abi: USDT_ABI,
    },
  },
  purchase: () =>
    Promise.reject("purchasing is not supported for this network"),
  stake: () => Promise.reject("staking is not supported for this network"),
  unstake: () => Promise.reject("unstaking is not supported for this network"),
};
